import React, { memo } from 'react'
import { FormValidation } from '@rjsf/utils'
import { useDispatch, useSelector } from 'react-redux'

import { useSettingsPopupState } from '../hooks'
import { useNlpModelForIntentId } from './hooks'
import { CustomFormPopup } from '../CustomFormPopup'
import { botNlpActions } from '../../../store/botNlp'
import { cleanEmptyProperties } from '../../../lib/rjsf'
import { ModalDescriptorForType } from '../../../store/modals'
import { schema, uiSchema, FormData, defaultFormData } from './constants'
import { trainingSourceBotIdSelector } from '../../../store/nlpEditor/selectors'
import { TextAreaWidget, TestSectionWidget, SuggestedIntentDescriptionWidget } from './widgets'
import { requestForProcessUtterance } from '../../nlp/TrainingTab/components/TrainingTab/components/implementations/NlpModel/actions/requestForProcessUtterance'

export type Props = { modalDescriptor: ModalDescriptorForType<'unmatched_utterance_settings'> }

export const UnmatchedUtteranceSettingsPopup: React.FC<Props> = memo(({ modalDescriptor }) => {
  const { intent, logGroup, partition, llmChatService = '' } = modalDescriptor

  const utterance = logGroup?.query || ''
  const description = intent?.description || ''
  const initialFormData = { ...defaultFormData, description, utterance, llmChatService }

  const dispatch = useDispatch()
  const model = useNlpModelForIntentId(intent.id)
  const botId = useSelector(trainingSourceBotIdSelector)
  const { formData, onFormDataChange } = useSettingsPopupState(() => initialFormData) as any

  return (
    <CustomFormPopup<FormData>
      title={`Edit description for Intent: ${intent?.name}`}
      labels={{ buttons: { submit: 'Accept', cancel: 'Cancel' } }}
      schema={schema}
      uiSchema={uiSchema}
      onChange={onFormDataChange}
      options={{ closeOnSubmit: true }}
      formData={cleanEmptyProperties(formData)}
      formContext={{ formData, initialFormData }}
      widgets={{ TextAreaWidget, TestSectionWidget, SuggestedIntentDescriptionWidget }}
      onSubmit={({ utterance, suggestedDescription }) => {
        if (!model) return
        if (suggestedDescription?.trim()) {
          dispatch(
            botNlpActions.updateModelIntentDescription({
              ...{ modelId: model.id, itemId: intent.id },
              newIntentDescription: suggestedDescription
            })
          )
        }
        dispatch(botNlpActions.addTestCase({ utterance, modelId: model.id, itemId: intent.id }))
        dispatch(
          requestForProcessUtterance({
            ...{ botId, logGroup, partition },
            ...{ modelId: model.id, intentId: intent.id }
          })
        )
      }}
    />
  )
})
